module.exports = __webpack_public_path__ + "img/burnley.cecf57c3.png";